import { combineReducers } from 'redux'
import { routerReducer } from 'react-router-redux'
import devicebitsRouter from '../containers/App/reducer'
import faqReducer from '../containers/FAQs/reducer'
import videosReducer from '../containers/Videos/reducer'
import guideReducer from '../containers/Guides/reducer'
import specsReducer from '../containers/Specs/reducer'
import tutorialsReducer from '../containers/Tutorials/reducer'
import relatedReducer from '../containers/RelatedSidebar/reducer'
import deviceReducer from '../containers/DeviceSelector/reducer'
import gettingStartedReducer from '../containers/GettingStarted/reducer'
import contactOptionsReducer from '../containers/ContactUsModal/reducer'
import userEventsReducer from '../containers/UserEvents/reducer'
import searchReducer from '../containers/ESSearch/reducer'
import footerReducer from '../containers/Footer/reducer'
import headerReducer from '../containers/Header/reducer'

const rootReducer = combineReducers({
  devicebits: devicebitsRouter,
  routing: routerReducer,
  faq: faqReducer,
  videos: videosReducer,
  guides: guideReducer,
  specs: specsReducer,
  tutorials: tutorialsReducer,
  related: relatedReducer,
  devices: deviceReducer,
  startercontent: gettingStartedReducer,
  contactoptions: contactOptionsReducer,
  userevents: userEventsReducer,
  search: searchReducer,
  footer: footerReducer,
  header: headerReducer
})

export default rootReducer



// WEBPACK FOOTER //
// ./src/store/reducer.js